import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import { Div, Loading, P } from 'konsys-ui'
import { CREATE_CLIENT, UPDATE_CLIENT } from '../../../constants/graphql/mutation'
import { GET_CLIENT } from '../../../constants/graphql/query'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { ActionBar } from '../../../components/client-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState(
    isAddMode ? {
      type: 'CLIENT',
      credit: '30',
    } : {},
  )

  let onChangeHandler = (id, value) => {
    setMutationVariables({
      typeOfChargeId: 1,
      ...mutationVariables,
      [id]: value,
    })
  }
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, onChangeHandler, mutationVariables)
          : isViewMode
            ? <Query
                query={GET_CLIENT}
                variables={{ id: props.match.params.id }}
              >{({ data, error, loading }) => {
                if (loading && _.isEmpty(data)) return <Loading center='true' />
                if (error) return <P>เกิดข้อผิดพลาด</P>
                return detailType(props.match.params, onChangeHandler, mutationVariables, data.customerInfo) // argument mode
              }}
              </Query>
            : <Query
                query={GET_CLIENT}
                variables={{ id: props.match.params.id }}
              >{({ data, error, loading }) => {
                if (loading && _.isEmpty(data)) return <Loading center='true' />
                if (error) return <P>เกิดข้อผิดพลาด</P>
                onChangeHandler = (id, value) => {
                  setMutationVariables({
                    companyId: data.customerInfo.companyId,
                    companyName: data.customerInfo.companyName,
                    credit: data.customerInfo.credit,
                    typeOfChargeId: data.customerInfo.TypeOfCharge.id,
                    groupId: data.customerInfo.groupId,
                    cargoType: _.map(data.customerInfo.cargoType, v => v.id),
                    ...mutationVariables,
                    [id]: value,
                  })
                }
                return detailType(props.match.params, onChangeHandler, mutationVariables, data.customerInfo) // argument mode
              }}
              </Query>
      }
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <Mutation
              mutation={isAddMode ? CREATE_CLIENT : UPDATE_CLIENT}
            >{(doAction, { loading }) => (
              <ActionBar
                loading={loading}
                disabled={(_.isUndefined(mutationVariables.companyName) || _.isEmpty(mutationVariables.companyName) || _.isUndefined(mutationVariables.groupId))
                  || _.size(mutationVariables) === 0 || _.isUndefined(mutationVariables.cargoType) || _.isEmpty(mutationVariables.cargoType)
                }
                isAddMode={isAddMode}
                isViewMode={isViewMode}
                doAction={doAction}
                mutationVariables={mutationVariables}
                props={props}
              />
            )}
            </Mutation>
          : <ActionBar
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
            />
      }
    </Div>
  )
}

export default Index
export { Index }
